export const TAG_COLOR_OPTIONS = [
    {
        id: 'red',
        background_color: '#F9E1E5',
        text_color: '#AF233A',
    },
    {
        id: 'yellow',
        background_color: '#FFF2CC',
        text_color: '#765A00',
    },
    {
        id: 'green',
        background_color: '#DDF3E4',
        text_color: '#287A3E',
    },
    {
        id: 'blue',
        background_color: '#DCEBFA',
        text_color: '#1E5F9A',
    },
    {
        id: 'purple',
        background_color: '#EEE4F8',
        text_color: '#70449A',
    },
];
